export const OperationsModes = {
    posProtectedAccess: "pos-protected-access",
    posSimpleAccess: "pos-simple-access",
    ecommerce: "ecommerce",
    ecommerceDemo: "ecommerce-demo",
    ecommerceBronze: "ecommerce-bronze",
    ecommerceSilver: "ecommerce-silver",
    ecommerceGold: "ecommerce-gold",
    ecommercePro: "ecommerce-pro",
    franchise: "franchise",
    develop: "develop",
    multiTenant: "multi-tenant"
};
